import {parseRawUrls} from '../common';

export default parseRawUrls({
  rilakkuma: 'http://www.stickpng.com/assets/thumbs/5a67a25201d15068bdfe87c9.png',
  rilakkuma1: 'https://i.pinimg.com/originals/1b/c3/3b/1bc33bdfd0ec831221b6ba454419001c.png',
  rilakkuma_and_friends:
    'https://lh3.googleusercontent.com/proxy/MijjSe3PS3XFNz36jTBCatc8Nw5hXkNYrvbgwOOheLF6AEPj0_tu1DdiA1M_2GON15ZTTM0Mpj-ACOOxO8CMADgrTldJcSJErZUsIWRjoup2sBC3-wo',
  pawn:
    'https://www.google.com/imgres?imgurl=https%3A%2F%2Fcdn3.vectorstock.com%2Fi%2F1000x1000%2F75%2F07%2Fchess-pawn-vector-347507.jpg&imgrefurl=https%3A%2F%2Fwww.vectorstock.com%2Froyalty-free-vector%2Fchess-pawn-vector-347507&docid=L8AObIMKdgXVoM&tbnid=xc5DNeckuBfYyM%3A&vet=10ahUKEwj5oZSB8bHdAhUKllQKHbMHB3MQMwjWASgDMAM..i&w=700&h=1080&bih=617&biw=1120&q=pawn&ved=0ahUKEwj5oZSB8bHdAhUKllQKHbMHB3MQMwjWASgDMAM&iact=mrc&uact=8',
  knight: 'https://static.thenounproject.com/png/337860-200.png',
  rook: 'https://static.thenounproject.com/png/1553132-200.png',
  bishop: 'https://thenounproject.com/term/chess/337861',
  queen:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLyR_o_IXIJE1-3GEqG6yPu95roaso7PNcs5lJuzmurpsQai_y3w',
  king:
    'https://image.spreadshirtmedia.com/image-server/v1/mp/designs/12774644,width=178,height=178/king-chess-pieces-king.png',
  steven: 'http://i64.tinypic.com/1zdaiv4.jpg',
  surprised_pikachu: 'https://emojis.slackmojis.com/emojis/images/1541014354/4885/surprised_pikachu.jpg',
  dark_moon: 'http://i68.tinypic.com/2vjrmg3.png',
});
